export default class A11ySkipContent {
  constructor(node) {
    this.node = node
    this.node.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick(e) {
    e.preventDefault()
    const href = this.node.getAttribute('href')
    const target = document.querySelector(href)
    const offsetTop = target.offsetTop

    scroll({ top: offsetTop, behavior: 'smooth' })

    target.focus()
  }
}
